export var SORT_TYPES = {
  1: 'DISTANCE',
  2: 'PRICE'
};
export var NEW_PI_SORT_TYPES = {
  1: 'RECOMMENDATION',
  2: 'DISTANCE',
  3: 'PRICE'
};
export var NEW_BB_SORT_TYPES = {
  1: 'DISTANCE',
  2: 'RECOMMENDATION',
  3: 'PRICE'
};